import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-license',
  templateUrl: './faq-license.component.html',
  styleUrls: ['./faq-license.component.css']
})
export class FaqLicenseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
